import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CommonPipesModule} from '../../../pipes/common-pipes.module';
import {LumiFormModule} from '../../form/lumi-form.module';
import {BaseTableModule} from '../shared/baseTable/baseTable.module';
import {CommonUIModule} from '../../commonUI/common-ui.module';
import {TableTabsComponent} from "./tableTabs.component";

@NgModule({
    exports: [TableTabsComponent],
    imports: [
        CommonModule,
        CommonPipesModule,
        LumiFormModule,
        BaseTableModule,
        CommonUIModule
    ],
    declarations: [
        TableTabsComponent
    ]
})
export class TableTabsModule {
    constructor() {
    }
}
